import type { FighterProfile, TrainingTier } from "@/types/game-data";

/**
 * Fighter profiles extracted from Spectre Operations 3rd Edition, pages 12-13.
 * Stats: M = Movement (inches), B = Ballistics, A = Awareness, S = Stress.
 * For B, A, S — lower is better.
 */
export const FIGHTER_PROFILES: Readonly<Record<TrainingTier, FighterProfile>> = {
	tier1: { movement: 6, ballistics: 3, awareness: 8, stress: 2 },
	tier2: { movement: 5, ballistics: 4, awareness: 9, stress: 3 },
	veteran: { movement: 5, ballistics: 5, awareness: 9, stress: 4 },
	enlisted: { movement: 5, ballistics: 6, awareness: 9, stress: 4 },
	militia: { movement: 5, ballistics: 7, awareness: 9, stress: 5 },
	conscript: { movement: 4, ballistics: 8, awareness: 10, stress: 6 },
	criminal: { movement: 4, ballistics: 8, awareness: 10, stress: 5 },
};

/** Lookup a fighter profile by training tier */
export function getFighterProfile(tier: TrainingTier): FighterProfile {
	return FIGHTER_PROFILES[tier];
}
